import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { DELETE_DMX_UNIVERSE } from './actionTypes';
import { deleteDmxUniverseSuccessful, deleteDmxUniverseFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* deleteUniverse({ payload: { universe } }) {
  try {
    const response = yield call(
      dmxAPI.deleteUniverse,
      universe.token,
      universe.controller_id,
      universe.id,
    );
    if (response.message) {
      yield put(deleteDmxUniverseSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deleteDmxUniverseFailed(error));
  }
}

export function* watchDeleteDmxUniverse() {
  yield takeEvery(DELETE_DMX_UNIVERSE, deleteUniverse);
}

function* deleteDmxUniverseSaga() {
  yield all([fork(watchDeleteDmxUniverse)]);
}

export default deleteDmxUniverseSaga;
